import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useRef, useState } from 'react';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import { useEditorContext } from '../../Context';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { useTranslation } from 'react-i18next';
import { isTouch as getIsTouch } from '../../../utils/browser';
const FullscreenEditor = ({ children, modalProps })=>{
    const { t } = useTranslation('editor');
    const editor = useEditorContext();
    const isTouch = getIsTouch();
    const [fsOpen, setFsOpen] = useState(false);
    const [currentState, setCurrentState] = useState(undefined);
    const toggleFs = useCallback(()=>{
        setCurrentState({
            doc: editor === null || editor === void 0 ? void 0 : editor.getJSON(),
            selection: editor === null || editor === void 0 ? void 0 : editor.state.selection.toJSON()
        });
        setFsOpen(!fsOpen);
    }, [
        editor,
        fsOpen
    ]);
    const scrollableRef = useRef(null);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !fsOpen && /*#__PURE__*/ React.createElement("div", null, children === null || children === void 0 ? void 0 : children(currentState, fsOpen, toggleFs, undefined)), fsOpen && /*#__PURE__*/ React.createElement(Modal, _object_spread_props(_object_spread({}, modalProps), {
        innerScrollRef: (node)=>{
            scrollableRef.current = node;
        },
        isOpen: fsOpen,
        onRequestClose: toggleFs,
        isFullscreen: true,
        useFixedMobileHeight: true,
        ipadMode: true,
        headerPadding: isTouch ? 'slim' : 'default',
        bodyScrollLockOptions: {
            allowTouchMove: (el)=>{
                // Slider
                // Inputs like ranges
                return el.closest('.menu-scrollable') !== null || el.tagName === 'INPUT' || el.closest('input') !== null;
            }
        },
        footerRight: [
            /*#__PURE__*/ React.createElement(SolidButton, {
                key: "done",
                onClick: toggleFs,
                size: isTouch ? 'medium' : 'large',
                variant: "approval-green"
            }, t('fullscreen.button.done'))
        ]
    }), children === null || children === void 0 ? void 0 : children(currentState, fsOpen, toggleFs, scrollableRef)));
};
FullscreenEditor.displayName = 'FullscreenEditor';
export default FullscreenEditor;

//# sourceMappingURL=Fullscreen.js.map